import React from 'react';
import Container from 'react-bootstrap/Container';
import './index.scss';

export default function ImpermaxV3Banner() {
  return (<Container className="impermax-v3-banner">
    <a className="card" href="https://app.impermax.finance" target="_blank">
      <b>IMPERMAX IS SHUTTING DOWN</b><br/>
      After 5 years of activity, our journey has sadly come to an end. We kindly ask you to withdraw your remaining funds deposited on our app.<br/>
      While Impermax smart contracts will keep working, our impermax.finance UI will shut down within the next few months.
      <br />
      Thanks for all the support, The Impermax Team
    </a>
  </Container>);
}
